import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Check, 
  ArrowRight, 
  ChevronDown, 
  ChevronUp, 
  ShoppingBag, 
  Award, 
  Clock, 
  Users,
  Plus,
  Minus
} from 'lucide-react';
import PublicNavbar from '@/Components/layout/PublicNavbar';
import PublicFooter from '@/Components/layout/PublicFooter';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { getNextActiveWaAdmin } from '@/utils/waRotator';


const maklonPackages = [
  {
    image: "/Paket Maklon/GRADE C - PAKET STANDART 30ml.png",
    grade: "GRADE C",
    title: "PAKET STANDART 30ML",
    size: "30ml",
    total: "Total 1.500 Pcs",
    price: "Rp 43.000.000",
    strikePrice: "Rp 53.000.000",
    discount: "Hemat 19%",
    popular: true,
    features: [
      "Total 1.500 Pcs - 3 Variant Botol 30ml",
      "Sticker & Box",
      "Monitoring Produksi Secara Online",
      "Banyak Pilihan Bibit Sesuai Grade",
      "Sampling / Revisi Sesuai Karakter Aroma",
      "Pendampingan Sampai Produk Siap Jual",
      "Free BPOM & HAKI",
      "Free Desain & Konsultasi"
    ]
  },
  {
    image: "/Paket Maklon/GRADE C - PAKET STANDART 50ml.png",
    grade: "GRADE C",
    title: "PAKET STANDART 50ML",
    size: "50ml",
    total: "Total 1.500 Pcs",
    price: "Rp 55.000.000",
    strikePrice: "Rp 65.000.000",
    discount: "Hemat 15%",
    features: [
      "Total 1.500 Pcs - 3 Variant Botol 50ml",
      "Sticker & Box",
      "Monitoring Produksi Secara Online",
      "Banyak Pilihan Bibit Sesuai Grade",
      "Sampling / Revisi Sesuai Karakter Aroma",
      "Pendampingan Sampai Produk Siap Jual",
      "Free BPOM & HAKI",
      "Free Desain & Konsultasi"
    ]
  },
  {
    image: "/Paket Maklon/GRADE B - PAKET SIGNATURE 30ml.png",
    grade: "GRADE B",
    title: "PAKET SIGNATURE 30ML",
    size: "30ml",
    total: "Total 1.500 Pcs",
    price: "Rp 69.250.000",
    strikePrice: "Rp 89.250.000",
    discount: "Hemat 22%",
    popular: true,
    features: [
      "Total 1.500 Pcs - 3 Variant Botol 30ml",
      "Sablon & Box Standar",
      "Monitoring Produksi Secara Online",
      "Pilihan Bibit Premium Grade B",
      "Sampling / Revisi Sesuai Karakter Aroma",
      "Pendampingan Sampai Produk Siap Jual",
      "Free BPOM & HAKI",
      "Free Desain & Konsultasi"
    ]
  },
  {
    image: "/Paket Maklon/GRADE B - PAKET SIGNATURE 50ml.png",
    grade: "GRADE B",
    title: "PAKET SIGNATURE 50ML",
    size: "50ml",
    total: "Total 1.500 Pcs",
    price: "Rp 90.250.000",
    strikePrice: "Rp 110.250.000",
    discount: "Hemat 18%",
    features: [
      "Total 1.500 Pcs - 3 Variant Botol 50ml",
      "Sablon & Box Standar",
      "Monitoring Produksi Secara Online",
      "Pilihan Bibit Premium Grade B",
      "Sampling / Revisi Sesuai Karakter Aroma",
      "Pendampingan Sampai Produk Siap Jual",
      "Free BPOM & HAKI",
      "Free Desain & Konsultasi"
    ]
  },
  {
    image: "/Paket Maklon/GRADE A - PAKET EXCLUSIVE 30ml.png",
    grade: "GRADE A",
    title: "PAKET EXCLUSIVE 30ML",
    size: "30ml",
    total: "Total 1.500 Pcs",
    price: "Rp 87.250.000",
    strikePrice: "Rp 117.250.000",
    discount: "Hemat 26%",
    features: [
      "Total 1.500 Pcs - 3 Variant Botol 30ml",
      "Sablon, Coloring, & Box",
      "Monitoring Produksi Secara Online",
      "Banyak Pilihan Bibit Dari Perfumer",
      "Sampling / Revisi Sesuai Karakter Aroma",
      "Pendampingan Sampai Produk Siap Jual",
      "Free BPOM & HAKI",
      "Free Desain & Konsultasi"
    ]
  },
  {
    image: "/Paket Maklon/GRADE A - PAKET EXCLUSIVE 50ml.png",
    grade: "GRADE A",
    title: "PAKET EXCLUSIVE 50ML",
    size: "50ml",
    total: "Total 1.500 Pcs",
    price: "Rp 114.250.000",
    strikePrice: "Rp 144.250.000",
    discount: "Hemat 21%",
    features: [
      "Total 1.500 Pcs - 3 Variant Botol 50ml",
      "Sablon, Coloring, & Box",
      "Monitoring Produksi Secara Online",
      "Banyak Pilihan Bibit Dari Perfumer",
      "Sampling / Revisi Sesuai Karakter Aroma",
      "Pendampingan Sampai Produk Siap Jual",
      "Free BPOM & HAKI",
      "Free Desain & Konsultasi"
    ]
  }
];

export default function Pricing() {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState(null);
  const formRef = useRef(null);

  useEffect(() => {
    // If there's a hash in the URL on load, scroll to it
    if (window.location.hash === '#form-konsultasi') {
      setTimeout(() => {
        formRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, 500); // slight delay to ensure layout is ready
    }
  }, []);

  const handleScrollToForm = (pkgValue) => {
    if (pkgValue) {
      setFormData(prev => ({ ...prev, paketPilihan: pkgValue }));
    }
    formRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // Calculator State
  const [moq, setMoq] = useState(1000);
  const [varian, setVarian] = useState(1);
  const [grade, setGrade] = useState("C");
  const [jenisParfum, setJenisParfum] = useState("Eau De Parfum");
  const [volume, setVolume] = useState("50");
  const [botol, setBotol] = useState("Standar");
  const [spray, setSpray] = useState("Biasa");
  const [finishing, setFinishing] = useState("Sticker");
  const [box, setBox] = useState("Tanpa Box");

  // Form State
  const [formData, setFormData] = useState({
    namaLengkap: '',
    namaBrand: '',
    noWa: '',
    email: '',
    paketPilihan: 'Custom Sesuai Keinginan Anda',
    kategoriCustom: '',
    varianCustom: '',
    moqCustom: '',
    pesan: ''
  });

  const [totalHpp, setTotalHpp] = useState(0);
  const [totalInvestasi, setTotalInvestasi] = useState(0);

  // Validation
  const numMoq = Number(moq) || 0;
  const numVarian = Number(varian) || 1;
  const isValidMoq = numMoq >= 1000;
  const pcsPerVarian = Math.floor(numMoq / numVarian);
  const isValidVarian = pcsPerVarian >= 300;

  const getPersentaseBibit = (jenis, gradePilihan) => {
    if (jenis === "Eau De Parfum") {
      if (gradePilihan === "A") return 15;
      if (gradePilihan === "B") return 20;
      if (gradePilihan === "C") return 15;
    } else {
      if (gradePilihan === "A") return 20;
      if (gradePilihan === "B") return 22;
      if (gradePilihan === "C") return 25;
    }
    return 15;
  };

  useEffect(() => {
    // Pricing Logic
    const persentaseBibit = getPersentaseBibit(jenisParfum, grade);
    const gradePrice = grade === "A" ? 3000 : grade === "B" ? 2000 : 1200;
    const bibitVol = volume * (persentaseBibit / 100);
    const solventVol = volume - bibitVol;
    
    const bibitCost = bibitVol * gradePrice;
    const solventCost = solventVol * 100;
    const botolCost = botol === "Premium" ? 14000 : 7000;
    const sprayCost = spray === "Continuous" ? 2000 : 0;
    const finishingCost = finishing === "Sablon" ? 2500 : 700;
    
    let boxCost = 0;
    if (box === "Softbox") boxCost = 10000;
    else if (box === "Semi Hardbox") boxCost = 17000;
    else if (box === "Hardbox") boxCost = 25000;

    const hpp = bibitCost + solventCost + botolCost + sprayCost + finishingCost + boxCost;
    setTotalHpp(hpp);
    setTotalInvestasi(hpp * (Number(moq) || 0));
  }, [moq, grade, jenisParfum, volume, botol, spray, finishing, box]);

  const handleWhatsApp = () => {
    if (!formData.namaLengkap || !formData.noWa) {
      alert("Harap lengkapi Nama dan Nomor WhatsApp.");
      return;
    }

    const admin = getNextActiveWaAdmin();

    let text = `Halo PT. Satala Dermatech Essential!\nSaya tertarik untuk maklon parfum dengan detail berikut:\n\n*INFORMASI KLIEN*\nNama: ${formData.namaLengkap}\nBrand: ${formData.namaBrand || '-'}\nNomor WA: ${formData.noWa}\nEmail: ${formData.email || '-'}\n\n`;

    if (formData.paketPilihan === 'Custom Sesuai Keinginan Anda') {
      text += `*DETAIL CUSTOM MAKLON*\nKategori: ${formData.kategoriCustom || '-'}\nJumlah Varian: ${formData.varianCustom || '-'} Varian\nTarget MOQ: ${formData.moqCustom || '-'} Pcs\n\n`;
    } else {
      text += `*PILIHAN PAKET*\nPaket: ${formData.paketPilihan}\n\n`;
    }

    text += `*PESAN / KEBUTUHAN KHUSUS*\n${formData.pesan || '-'}\n\nMohon informasi lebih lanjut. Terima kasih!`;

    const phone = admin.phone.replace(/[^0-9]/g, '');
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(text)}`, '_blank');
  };

  const faqs = [
    { q: "Berapa MOQ minimum untuk maklon di Satala Dermatech?", a: "MOQ minimum untuk paket maklon parfum kami sangat terjangkau, yaitu dimulai dari 1.500 pcs." },
    { q: "Apakah harga sudah termasuk registrasi BPOM dan HAKI?", a: "Tentu saja! Semua paket maklon kami sudah termasuk biaya registrasi BPOM dan pengurusan HAKI secara gratis (Free)." },
    { q: "Apakah saya bisa menggunakan formula aroma sendiri?", a: "Bisa. Kami memfasilitasi penggunaan atau penyesuaian formula khusus (Custom Formula) sesuai dengan karakteristik brand Anda." },
    { q: "Apakah bisa custom kemasan sesuai branding saya?", a: "Sangat bisa. Kami menyediakan berbagai pilihan packaging eksklusif yang dapat disesuaikan." },
    { q: "Apakah ada bantuan untuk desain produk dan kemasan?", a: "Pasti! Kami memberikan fasilitas Free Design. Tim ahli kami akan mendampingi Anda penuh untuk membuat visual produk yang bagus, mewah, dan siap bersaing di pasaran." },
    { q: "Apakah ada dukungan untuk jualan online (e-commerce)?", a: "Ya, kami tidak sekadar memproduksi. Kami juga memberikan pendampingan after-sales berupa strategi pemasaran di e-commerce agar brand Anda tumbuh dengan sukses." }
  ];

  return (
    <div className="min-h-screen bg-[#FCFAF6] font-sans text-[#302621] selection:bg-[#D4AF37] selection:text-white">
      <PublicNavbar />

      {/* HERO SECTION */}
      <section className="relative pt-24 pb-16 lg:pt-32 lg:pb-24 overflow-hidden" data-aos="fade-up">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#D4AF37]/5 rounded-full blur-[100px] -z-10 translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#302621]/5 rounded-full blur-[80px] -z-10 -translate-x-1/2 translate-y-1/2"></div>
        
        <div className="container mx-auto px-6 lg:px-12 relative z-10">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="lg:w-1/2">
              <span className="inline-block py-1.5 px-4 bg-[#E6D5B8]/40 text-[#8C6208] text-[10px] font-bold tracking-widest uppercase rounded mb-4">
                PAKET MAKLON PARFUM
              </span>
              <h1 className="text-4xl lg:text-5xl font-bold leading-tight mb-6 tracking-tight">
                Pilih Paket Maklon yang Sesuai dengan Tahap Pertumbuhan Brand Anda
              </h1>
              <p className="text-lg text-[#7A695B] mb-8 max-w-xl font-light leading-relaxed">
                Mulai dari brand yang baru merintis hingga perusahaan yang ingin mengembangkan produk premium berskala besar, kami menyediakan solusi maklon yang fleksibel dan terukur.
              </p>
              <div className="flex flex-wrap items-center gap-4">
                <button 
                  onClick={() => handleScrollToForm()}
                  className="bg-[#D4AF37] hover:bg-[#B58B22] text-white px-8 py-4 rounded-lg font-bold shadow-lg shadow-[#D4AF37]/20 border-0 transition-transform hover:-translate-y-1 flex items-center gap-2"
                >
                  Konsultasi Gratis <ArrowRight className="w-4 h-4" />
                </button>
                <button 
                  onClick={() => document.getElementById('list-paket')?.scrollIntoView({ behavior: 'smooth' })}
                  className="bg-transparent border border-[#302621] text-[#302621] hover:bg-[#302621] hover:text-white px-8 py-4 rounded-lg font-bold transition-all hover:-translate-y-1"
                >
                  Lihat Paket
                </button>
              </div>
            </div>
            <div className="lg:w-1/2">
              {/* Image */}
              <div className="relative w-full rounded-3xl overflow-hidden shadow-2xl flex items-center justify-center bg-gray-100">
                 <img src="/Paket Maklon/Paket Sedikit Landscape.png" alt="Parfum Products" className="w-full h-auto object-contain transition-transform duration-700 hover:scale-105" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="py-8 bg-white border-y border-[#E6D5B8]/30">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-[#E6D5B8]/30">
            <div className="flex items-center gap-4 px-4">
              <div className="w-12 h-12 bg-[#FCFAF6] rounded-full flex items-center justify-center text-[#D4AF37]">
                <ShoppingBag className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-[#302621]">150+</h3>
                <p className="text-xs text-[#7A695B] font-bold uppercase tracking-wider">Brand Bermitra</p>
              </div>
            </div>
            <div className="flex items-center gap-4 px-4">
              <div className="w-12 h-12 bg-[#FCFAF6] rounded-full flex items-center justify-center text-[#D4AF37]">
                <Award className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-[#302621]">600+</h3>
                <p className="text-xs text-[#7A695B] font-bold uppercase tracking-wider">Produk Diproduksi</p>
              </div>
            </div>
            <div className="flex items-center gap-4 px-4">
              <div className="w-12 h-12 bg-[#FCFAF6] rounded-full flex items-center justify-center text-[#D4AF37]">
                <Check className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-[#302621]">MOQ</h3>
                <p className="text-xs text-[#7A695B] font-bold uppercase tracking-wider">Rendah</p>
              </div>
            </div>
            <div className="flex items-center gap-4 px-4">
              <div className="w-12 h-12 bg-[#FCFAF6] rounded-full flex items-center justify-center text-[#D4AF37]">
                <Users className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-[#302621]">100%</h3>
                <p className="text-xs text-[#7A695B] font-bold uppercase tracking-wider">Dukungan Tim Ahli</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING CARDS */}
      <section className="py-24 bg-[#FCFAF6]">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <span className="inline-block py-1.5 px-4 bg-[#E6D5B8]/40 text-[#8C6208] text-[10px] font-bold tracking-widest uppercase rounded mb-4">
              PAKET MAKLON KAMI
            </span>
            <h2 className="text-3xl lg:text-4xl font-bold mb-4 text-[#302621]">Pilih Paket yang Tepat untuk Brand Anda</h2>
            <p className="text-[#7A695B] max-w-2xl mx-auto font-light leading-relaxed">Setiap paket dirancang untuk memenuhi kebutuhan bisnis yang berbeda, mulai dari startup hingga enterprise.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {maklonPackages.map((pkg, idx) => (
              <div key={idx} className={`bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-300 border flex flex-col group ${pkg.popular ? 'border-[#D4AF37] ring-4 ring-[#D4AF37]/10 transform hover:-translate-y-2' : 'border-[#E6D5B8]/30 hover:-translate-y-1'}`}>
                
                {/* Header Image */}
                <div className="relative w-full bg-[#FCFAF6] p-4 cursor-pointer border-b border-[#E6D5B8]/30 overflow-hidden">
                  <img src={pkg.image} alt={pkg.title} className="w-full h-auto object-contain filter grayscale opacity-90 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-[1.02] transition-all duration-700" />
                  {pkg.popular && (
                    <div className="absolute top-4 right-4 bg-[#D4AF37] text-white text-[10px] font-bold px-3 py-1.5 rounded-full tracking-widest shadow-md z-10">
                      TERLARIS
                    </div>
                  )}
                </div>

                {/* Content */}
                <div className="p-6 flex flex-col flex-1">
                  <div className="mb-6">
                    <span className="text-[#8C6208] text-xs font-bold tracking-wider mb-1 block">{pkg.grade} - {pkg.size}</span>
                    <h3 className="text-[#302621] text-xl font-black leading-tight mb-4">{pkg.title}</h3>
                    
                    <div className="flex flex-col">
                      <div className="flex items-center gap-2">
                        <span className="text-gray-400 text-sm line-through font-semibold">{pkg.strikePrice}</span>
                        <span className="bg-red-100 text-red-600 text-[10px] font-bold px-2 py-0.5 rounded-full">{pkg.discount}</span>
                      </div>
                      <span className="text-[#D4AF37] text-3xl font-extrabold">{pkg.price}</span>
                    </div>
                  </div>

                  <div className="bg-[#FCFAF6] border border-[#E6D5B8]/40 rounded-lg p-3 text-center mb-6">
                    <span className="text-[#8C6208] text-[10px] font-bold tracking-wider uppercase">Kapasitas Produksi</span>
                    <div className="text-[#302621] font-black text-lg">{pkg.total}</div>
                  </div>
                  
                  <ul className="space-y-3 mb-8 flex-1">
                    {pkg.features.map((feat, i) => (
                      <li key={i} className="flex items-start gap-3">
                        <div className="mt-0.5 shrink-0 w-4 h-4 rounded-full bg-[#D4AF37]/20 flex items-center justify-center">
                          <Check className="w-2.5 h-2.5 text-[#D4AF37]" />
                        </div>
                        <span className="text-sm text-[#302621] font-medium leading-tight">{feat}</span>
                      </li>
                    ))}
                  </ul>

                  <button 
                    onClick={() => {
                      const juta = pkg.price.replace("Rp ", "").replace(".000.000", "").replace(".250.000", ".25");
                      const nameParts = pkg.title.split(" ");
                      const type = nameParts[1].charAt(0) + nameParts[1].slice(1).toLowerCase();
                      const size = nameParts[2].toLowerCase();
                      const formVal = `Paket ${type} ${size} (Rp ${juta} Juta)`;
                      handleScrollToForm(formVal);
                    }}
                    className={`w-full block text-center py-3.5 rounded-xl font-bold transition-all ${pkg.popular ? 'bg-[#D4AF37] text-white hover:bg-[#B58B22] shadow-lg shadow-[#D4AF37]/30' : 'bg-white border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white'}`}
                  >
                    Konsultasi Paket Ini
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* COMPARISON TABLE */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6 lg:px-12 overflow-x-auto">
          <div className="mb-10">
            <span className="text-[#D4AF37] font-bold tracking-wider text-sm mb-2 block uppercase">Perbandingan Paket</span>
            <h2 className="text-3xl font-extrabold">Bandingkan Paket Maklon</h2>
          </div>
          
          <table className="w-full min-w-[800px] text-left border-collapse">
            <thead>
              <tr className="border-b-2 border-[#D4AF37]">
                <th className="py-4 px-4 font-bold w-1/4">Fitur</th>
                <th className="py-4 px-4 font-bold text-center w-1/4">Grade C (Standart)</th>
                <th className="py-4 px-4 font-bold text-center w-1/4">Grade B (Signature)</th>
                <th className="py-4 px-4 font-bold text-center w-1/4">Grade A (Exclusive)</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {[
                { name: "MOQ Minimum", c: "1.500 pcs (3 Variant)", b: "1.500 pcs (3 Variant)", a: "1.500 pcs (3 Variant)" },
                { name: "Pilihan Botol", c: "Standard", b: "Signature", a: "Premium / Eksklusif" },
                { name: "Formulasi", c: "Full Formulasi", b: "Full Formulasi", a: "Full Formulasi" },
                { name: "Kualitas Bibit", c: "Banyak Pilihan Sesuai Grade", b: "Premium (Grade B)", a: "Banyak Pilihan Premium" },
                { name: "Sablon & Packaging", c: "Sticker & Box", b: "Sablon & Box Standar", a: "Sablon, Coloring, & Softbox" },
                { name: "Registrasi BPOM & HAKI", c: true, b: true, a: true },
                { name: "Desain & Konsultasi", c: true, b: "Desain Eksklusif", a: "Desain Eksklusif" },
                { name: "Monitoring Produksi Online", c: true, b: true, a: true },
                { name: "Pendampingan Brand", c: "Sampai Siap Jual", b: "Sampai Siap Jual", a: "Sampai Siap Jual" },
              ].map((row, idx) => (
                <tr key={idx} className="hover:bg-gray-50">
                  <td className="py-4 px-4 text-sm font-medium">{row.name}</td>
                  <td className="py-4 px-4 text-center">
                    {row.c === true ? <Check className="w-5 h-5 text-[#D4AF37] mx-auto"/> : row.c === false ? <span className="text-gray-300">-</span> : <span className="text-sm font-medium">{row.c}</span>}
                  </td>
                  <td className="py-4 px-4 text-center">
                    {row.b === true ? <Check className="w-5 h-5 text-[#D4AF37] mx-auto"/> : row.b === false ? <span className="text-gray-300">-</span> : <span className="text-sm font-medium">{row.b}</span>}
                  </td>
                  <td className="py-4 px-4 text-center">
                    {row.a === true ? <Check className="w-5 h-5 text-[#D4AF37] mx-auto"/> : row.a === false ? <span className="text-gray-300">-</span> : <span className="text-sm font-medium">{row.a}</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* CALCULATOR & PROPOSAL */}
      <section className="py-16 bg-[#FCFAF6]">
        <div className="container mx-auto px-6 lg:px-12 max-w-4xl">
          <div className="flex flex-col gap-12">
            
            {/* Top: Calculator */}
            {false && (
            <div className="bg-white border border-gray-100 rounded-2xl p-8 shadow-sm">
              <h3 className="text-2xl font-bold mb-2">Hitung Estimasi Custom Anda</h3>
              <p className="text-sm text-gray-500 mb-8">Dapatkan perkiraan biaya sesuai spesifikasi parfum brand Anda.</p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                {/* MOQ & Varian */}
                <div className="space-y-4 col-span-1 md:col-span-2 p-5 bg-[#F9F5EC] rounded-xl border border-[#E8DCC8]">
                  <h4 className="font-bold text-sm text-[#302621]">Kuantitas Produksi</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs font-semibold text-gray-600 mb-1">Total MOQ (Min. 1000)</label>
                      <input 
                        type="number" 
                        min="1000"
                        step="1"
                        value={moq === 0 && moq !== '' ? '' : moq} 
                        onChange={(e) => setMoq(e.target.value === '' ? '' : Number(e.target.value.replace(/[^0-9]/g, '')))}
                        className={`w-full border rounded p-3 text-sm focus:ring-[#D4AF37] focus:border-[#D4AF37] ${!isValidMoq ? 'border-red-500' : 'border-gray-200'}`}
                      />
                      {!isValidMoq && <p className="text-xs text-red-500 mt-1">Minimal MOQ adalah 1.000 pcs</p>}
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-gray-600 mb-1">Jumlah Varian Aroma</label>
                      <input 
                        type="number" 
                        min="1"
                        step="1"
                        value={varian === 0 && varian !== '' ? '' : varian} 
                        onChange={(e) => setVarian(e.target.value === '' ? '' : Number(e.target.value.replace(/[^0-9]/g, '')))}
                        className={`w-full border rounded p-3 text-sm focus:ring-[#D4AF37] focus:border-[#D4AF37] ${!isValidVarian ? 'border-red-500' : 'border-gray-200'}`}
                      />
                      <p className={`text-xs mt-1 ${isValidVarian ? 'text-gray-500' : 'text-red-500 font-bold'}`}>
                        Estimasi: {pcsPerVarian} pcs / varian {isValidVarian ? '(Aman)' : '(Min. 300 pcs/varian)'}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Spesifikasi Cairan */}
                <div className="space-y-4">
                  <h4 className="font-bold text-sm text-[#302621] border-b pb-2">Spesifikasi Cairan</h4>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Grade Bibit Parfum</label>
                    <Select value={grade} onValueChange={setGrade}>
                      <SelectTrigger className="w-full border-gray-200 focus:ring-[#D4AF37] h-[46px] bg-white text-sm">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="A">Grade A (Exclusive - Terbaik)</SelectItem>
                        <SelectItem value="B">Grade B (Premium)</SelectItem>
                        <SelectItem value="C">Grade C (Standard)</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Jenis Parfum</label>
                    <Select value={jenisParfum} onValueChange={setJenisParfum}>
                      <SelectTrigger className="w-full border-gray-200 focus:ring-[#D4AF37] h-[46px] bg-white text-sm">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="Eau De Parfum">Eau De Parfum</SelectItem>
                        <SelectItem value="Extrait De Parfum">Extrait De Parfum</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Ukuran Volume</label>
                    <Select value={volume.toString()} onValueChange={(v) => setVolume(Number(v))}>
                      <SelectTrigger className="w-full border-gray-200 focus:ring-[#D4AF37] h-[46px] bg-white text-sm">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="10">10 ml</SelectItem>
                        <SelectItem value="30">30 ml</SelectItem>
                        <SelectItem value="50">50 ml</SelectItem>
                        <SelectItem value="100">100 ml</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>

                {/* Spesifikasi Kemasan */}
                <div className="space-y-4">
                  <h4 className="font-bold text-sm text-[#302621] border-b pb-2">Spesifikasi Kemasan</h4>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Pilihan Botol Kaca</label>
                    <Select value={botol} onValueChange={setBotol}>
                      <SelectTrigger className="w-full border-gray-200 focus:ring-[#D4AF37] h-[46px] bg-white text-sm">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="Standar">Kaca Standar</SelectItem>
                        <SelectItem value="Premium">Kaca Premium</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Tipe Spray</label>
                    <Select value={spray} onValueChange={setSpray}>
                      <SelectTrigger className="w-full border-gray-200 focus:ring-[#D4AF37] h-[46px] bg-white text-sm">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="Biasa">Biasa (Crimp/Drat)</SelectItem>
                        <SelectItem value="Continuous">Continuous Spray</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs font-semibold text-gray-600 mb-1">Finishing</label>
                      <Select value={finishing} onValueChange={setFinishing}>
                        <SelectTrigger className="w-full border-gray-200 focus:ring-[#D4AF37] h-[46px] bg-white text-sm">
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="Sticker">Sticker</SelectItem>
                          <SelectItem value="Sablon">Sablon</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-gray-600 mb-1">Kemasan Box</label>
                      <Select value={box} onValueChange={setBox}>
                        <SelectTrigger className="w-full border-gray-200 focus:ring-[#D4AF37] h-[46px] bg-white text-sm">
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="Tanpa Box">Tanpa Box</SelectItem>
                          <SelectItem value="Softbox">Softbox</SelectItem>
                          <SelectItem value="Semi Hardbox">Semi Hardbox</SelectItem>
                          <SelectItem value="Hardbox">Hardbox</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  </div>
                </div>
              </div>

              {/* Total Calculation Output */}
              <div className="bg-[#302621] text-white rounded-xl p-6 flex flex-col md:flex-row justify-between items-center gap-6 shadow-xl relative overflow-hidden">
                <div className="absolute top-0 right-0 opacity-10 w-32 h-32 transform translate-x-8 -translate-y-8">
                  <svg viewBox="0 0 100 100" fill="currentColor"><circle cx="50" cy="50" r="50"/></svg>
                </div>
                
                <div className="z-10 w-full text-center md:text-left">
                  <p className="text-sm text-gray-300 mb-1">Estimasi Harga Pokok Produksi (HPP)</p>
                  <div className="text-xl font-bold text-[#D4AF37] mb-2">Rp {totalHpp.toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} <span className="text-xs font-normal text-gray-400">/ pcs</span></div>
                </div>
                
                <div className="h-[1px] w-full md:w-[1px] md:h-16 bg-gray-600 z-10 hidden md:block"></div>
                
                <div className="z-10 w-full text-center md:text-right">
                  <p className="text-sm text-gray-300 mb-1">Total Estimasi Biaya</p>
                  <div className="text-3xl font-extrabold text-white">Rp {totalInvestasi.toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                  <p className="text-xs text-gray-400 mt-1">Untuk {moq} pcs ({varian} varian)</p>
                </div>
              </div>
              
              <div className="mt-4 p-4 bg-yellow-50/50 border border-yellow-100 rounded-lg flex gap-3 text-yellow-800 text-xs shadow-sm">
                <svg className="w-4 h-4 flex-shrink-0 text-yellow-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p>
                  <strong>Catatan Penting:</strong> Kalkulasi ini hanyalah estimasi awal. Harga aktual/final bisa menjadi lebih murah atau lebih mahal, tergantung pada kerumitan formula, pemilihan spesifikasi detail aksesoris kemasan, serta promo yang sedang berlangsung.
                </p>
              </div>
            </div>
            )}

            {/* Bottom: Consultation Form */}
            <div id="form-konsultasi" ref={formRef} className="bg-white border border-gray-100 rounded-2xl p-8 shadow-sm relative scroll-mt-24">
              <h3 className="text-2xl font-bold mb-2">Konsultasikan Rencana Maklon Anda</h3>
              <p className="text-sm text-gray-500 mb-8">Diskusikan paket pilihan Anda (Standart, Signature, Exclusive) atau hasil estimasi custom bersama tim representatif kami via WhatsApp.</p>
              
              <form className="space-y-5">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Nama Lengkap *</label>
                    <input 
                      type="text" 
                      value={formData.namaLengkap} onChange={(e) => setFormData({...formData, namaLengkap: e.target.value})}
                      className="w-full border border-gray-200 rounded p-3 text-sm focus:ring-[#D4AF37] focus:border-[#D4AF37]" 
                      placeholder="Nama Lengkap" 
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">
                      Nama Brand <span className="font-normal italic text-gray-400">(Boleh dikosongkan jika belum ada)</span>
                    </label>
                    <input 
                      type="text" 
                      value={formData.namaBrand} onChange={(e) => setFormData({...formData, namaBrand: e.target.value})}
                      className="w-full border border-gray-200 rounded p-3 text-sm focus:ring-[#D4AF37] focus:border-[#D4AF37]" 
                      placeholder="Nama Brand" 
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Nomor WhatsApp *</label>
                    <input 
                      type="text" 
                      value={formData.noWa} onChange={(e) => setFormData({...formData, noWa: e.target.value})}
                      className="w-full border border-gray-200 rounded p-3 text-sm focus:ring-[#D4AF37] focus:border-[#D4AF37]" 
                      placeholder="08..." 
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Email</label>
                    <input 
                      type="email" 
                      value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})}
                      className="w-full border border-gray-200 rounded p-3 text-sm focus:ring-[#D4AF37] focus:border-[#D4AF37]" 
                      placeholder="email@contoh.com" 
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Pilihan Paket Maklon</label>
                  <Select value={formData.paketPilihan} onValueChange={(val) => setFormData({...formData, paketPilihan: val})}>
                    <SelectTrigger className="w-full">
                      <SelectValue placeholder="Pilih Paket" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="Custom Sesuai Keinginan Anda">Custom Sesuai Keinginan Anda</SelectItem>
                      <SelectItem value="Paket Standart 30ml (Rp 43 Juta)">Paket Standart 30ml (Rp 43 Juta)</SelectItem>
                      <SelectItem value="Paket Standart 50ml (Rp 55 Juta)">Paket Standart 50ml (Rp 55 Juta)</SelectItem>
                      <SelectItem value="Paket Signature 30ml (Rp 69.25 Juta)">Paket Signature 30ml (Rp 69.25 Juta)</SelectItem>
                      <SelectItem value="Paket Signature 50ml (Rp 90.25 Juta)">Paket Signature 50ml (Rp 90.25 Juta)</SelectItem>
                      <SelectItem value="Paket Exclusive 30ml (Rp 87.25 Juta)">Paket Exclusive 30ml (Rp 87.25 Juta)</SelectItem>
                      <SelectItem value="Paket Exclusive 50ml (Rp 114.25 Juta)">Paket Exclusive 50ml (Rp 114.25 Juta)</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                {formData.paketPilihan === 'Custom Sesuai Keinginan Anda' && (
                  <div className="space-y-5 p-5 bg-[#F9F5EC] rounded-xl border border-[#E6D5B8]">
                    <div>
                      <label className="block text-xs font-semibold text-[#8C6208] mb-1">Kategori yang Diinginkan</label>
                      <Select value={formData.kategoriCustom} onValueChange={(val) => setFormData({...formData, kategoriCustom: val})}>
                        <SelectTrigger className="w-full bg-white border-white">
                          <SelectValue placeholder="Pilih Kategori Produk" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="Extrait de Parfum">Extrait de Parfum</SelectItem>
                          <SelectItem value="Eau De Parfum (EDP)">Eau De Parfum (EDP)</SelectItem>
                          <SelectItem value="Eau De Toilette (EDT)">Eau De Toilette (EDT)</SelectItem>
                          <SelectItem value="Hair & Body Mist">Hair & Body Mist</SelectItem>
                          <SelectItem value="Discovery Set">Discovery Set</SelectItem>
                          <SelectItem value="Reed Diffuser">Reed Diffuser</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                      <div>
                        <label className="block text-xs font-semibold text-[#8C6208] mb-1">Berapa Variant</label>
                        <input 
                          type="number" 
                          min="1"
                          value={formData.varianCustom} onChange={(e) => setFormData({...formData, varianCustom: e.target.value})}
                          className="w-full border border-transparent rounded p-3 text-sm focus:ring-[#D4AF37] focus:border-[#D4AF37]" 
                          placeholder="Misal: 2" 
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-semibold text-[#8C6208] mb-1">Berapa MOQ (Pcs)</label>
                        <input 
                          type="number" 
                          min="1000"
                          step="100"
                          value={formData.moqCustom} onChange={(e) => setFormData({...formData, moqCustom: e.target.value})}
                          className="w-full border border-transparent rounded p-3 text-sm focus:ring-[#D4AF37] focus:border-[#D4AF37]" 
                          placeholder="Misal: 1000" 
                        />
                      </div>
                    </div>
                    <p className="text-[11px] text-[#7A695B] italic leading-tight">
                      *Note: Minimal pemesanan adalah 500 pcs/variant, dengan total MOQ keseluruhan minimal 1.000 pcs.
                    </p>
                  </div>
                )}

                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Pesan / Kebutuhan Khusus</label>
                  <textarea 
                    rows="3" 
                    value={formData.pesan} onChange={(e) => setFormData({...formData, pesan: e.target.value})}
                    className="w-full border border-gray-200 rounded p-3 text-sm focus:ring-[#D4AF37] focus:border-[#D4AF37]" 
                    placeholder="Ceritakan detail tambahan yang Anda inginkan... (Opsional)"
                  ></textarea>
                </div>
                <button 
                  type="button" 
                  onClick={handleWhatsApp}
                  className="w-full bg-[#D4AF37] hover:bg-[#B58B22] text-white py-4 rounded-xl font-bold text-lg shadow-lg shadow-[#D4AF37]/20 transition-all hover:-translate-y-1 mt-4"
                >
                  Hubungi via WhatsApp
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-16 bg-white border-t border-gray-100">
        <div className="container mx-auto px-6 lg:px-12 max-w-4xl">
          <div className="text-center mb-10">
            <span className="text-[#D4AF37] font-bold tracking-wider text-sm mb-2 block uppercase">FAQ</span>
            <h2 className="text-3xl font-extrabold">Pertanyaan yang Sering Diajukan</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
            {faqs.map((faq, idx) => (
              <div key={idx} className="border border-gray-200 rounded-lg overflow-hidden h-max">
                <button 
                  onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                  className="w-full flex items-center justify-between p-4 text-left bg-white hover:bg-gray-50 transition-colors"
                >
                  <span className="font-semibold text-sm">{faq.q}</span>
                  {openFaq === idx ? <Minus className="w-4 h-4 text-[#D4AF37] flex-shrink-0" /> : <Plus className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />}
                </button>
                {openFaq === idx && (
                  <div className="p-4 pt-0 text-sm text-gray-600 bg-white">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="py-16 md:py-24 px-6 lg:px-12 bg-[#FCFAF6]">
        <div className="container mx-auto max-w-6xl">
          <div className="bg-[#EFE8D8] rounded-3xl overflow-hidden relative shadow-sm border border-[#E6D5B8]/50">
            <div className="absolute right-0 top-0 bottom-0 w-1/2 opacity-100 mix-blend-multiply hidden md:block">
              <img src="/Gambar Web/Botol berdiri.png" alt="Products" className="w-full h-full object-cover mask-image-gradient-left" />
            </div>
            <div className="relative z-10 p-12 md:p-16 w-full md:w-[55%] lg:w-1/2">
              <h2 className="text-3xl md:text-4xl font-extrabold text-[#302621] mb-4 leading-tight">Siap Membangun Brand Parfum Anda?</h2>
              <p className="text-[#7A695B] text-lg leading-relaxed mb-8">
                Mulai perjalanan brand Anda bersama para perfumer ahli kami. Ciptakan aroma signature yang mewah dan tak terlupakan.
              </p>
              <button className="bg-[#D4AF37] hover:bg-[#B58B22] text-white px-8 py-4 text-base rounded-lg shadow-md border-0 transition-transform hover:-translate-y-1 font-semibold flex items-center">
                Konsultasi Gratis <ArrowRight className="w-4 h-4 ml-2" />
              </button>
            </div>
          </div>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
}

